// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2e0lv","consentsList":"PatientConsents_consentsList__dA29M","consentsListEmpty":"PatientConsents_consentsListEmpty__1fYMe"};